import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { RequireAuth, RequireAdmin } from '../utils/auth'

import { RequireAuthDesktop } from '../utils/desktop-auth'

import Hybrid from '../components/Hybrid'
import Dashboard from '../views/Dashboard/dashboard'
import AnalyticsOld from '../components/Analytics'
import Analytics from '../views/Analytics'
import Layout from '../views/Layout'
import Login from '../views/Auth/Login'

import OktaLogin from '../views/Auth/OktaLogin'
import Register from '../views/Auth/Register'
import WebRegister from '../views/Auth/Webregister'
import S3Direct from '../views/S3Direct'
import Encoding from '../views/Encoding'
import Hybrik from '../views/Hybrik'
import Search from '../views/Mam'
import Wasabi from '../views/Wasabi'
import FileCatalyst from '../views/FileCatalyst'
import AddProvider from '../views/Clouds/AddProvider'
import AddBucket from '../components/Hybrid/AddBucket'
import SetAlert from '../views/Notifications/SetAlert'
import CloudCompare from '../components/CloudCompare'
import Finance from '../components/Finance'
import LogsView from '../components/Finance/LogsView'
import Settings from '../layouts/Settings'
import ProfileDetails from '../views/Settings/ProfileDetails'
import EditProfile from '../views/Settings/EditProfile'
import ChangePassword from '../views/Auth/ChangePassword'
import BillingDetails from '../views/Billing/BillingDetails'
import AddCreditCard from '../views/Billing/AddCreditCard'

import UserList from '../views/Settings/UserList'
import UserPage from '../views/Settings/UserPage'
import MFAPage from '../views/Settings/MFAPage'
import RoleList from '../views/Settings/RoleList'
import SecurityCredentials from '../views/Settings/SecurityCredentials'
import PostSignUp from '../views/Auth/PostSignUp'
import OldResetPassword from '../views/Auth/OldResetPassword'
import VerifyUser from '../views/Auth/VerifyUser'
import PlanDetails from '../views/Billing/PlanDetails'
import Pricings from '../views/Billing/Pricings'
import Transfer from '../views/TransferDashboard'
import TransferWasabi from '../views/TransferDashboardWasabi'
import TransferLambda from '../views/TransferDashboardLambda'
import Xchange from '../views/Xchange'
import XchangeAWS from '../views/XchangeAWS'
import XchangeAWS2 from '../views/XchangeAWS2'
import XchangeWasabi from '../views/XchangeWasabi'
import SyncC2c from '../views/SyncC2c'
// import SyncC2cWasabi from '../views/SyncC2cWasabi'
import SyncC2cWasabi from '../views/SyncC2cWasabi/SyncC2cWasabi'
import CalcPrice from '../views/CalculatePrice'


import ResetPassword from '../views/Auth/ResetPassword/resetPassword';
import VerifyEmail from '../views/Auth/VerifyEmail/verifyEmail';
import CloudProviders from '../components/CloudProviders';
// import AdminDashboard from '../views/AdminDashboard/adminDashboard';
import UserDashboard from '../views/UsersListDashboard/usersListDashboard';
// import EachUserDashboard from '../views/UserDashboard/userDashboard';
import UsageDetail from '../views/UsersListDashboard/UsageDetail/usageDetail';
import TransferCostDetail from '../views/UsersListDashboard/UsageDetail/TransferCostDetail/transferCostDetail';
import AdmindAccount from '../views/AdminAccount/adminAccount';
import AddNewAccount from '../views/AdminAccount/AddNewAccount/addNewAccount';
import AddNewUser from '../views/UsersListDashboard/AddNewUser/addNewUser';

export default (
  <Switch>
    <Route path="/login/:referrer_id?" component={Login} />
    <Route path="/resetpassword/:token?" component={ResetPassword} />
    <Route path="/oktalogin/:referrer_id?" component={OktaLogin} />
    <Route path="/register/:referrer_id?" component={Register} />

    <Route path="/signup/:referrer_id?" component={WebRegister} />
    <Route path="/postSignup" component={PostSignUp} />
    <Route path="/reset_password/:token?" component={ResetPassword} />
    <Route path="/verify/:token?" component={VerifyUser} />
    

    

    <Layout path="/analytics-old" component={RequireAuth(AnalyticsOld)} />
    <Layout
      path="/analytics"
      component={RequireAuth(Analytics)}
      fullHeight={true}
    />
    <Layout path="/S3Direct" component={RequireAuth(S3Direct)} />
    <Layout path="/wasabi" component={RequireAuth(Wasabi)} />
    <Layout path="/transfers" component={RequireAuth(FileCatalyst)} />
    {/* <Layout path="/addProvider" component={RequireAuth(AddProvider)} /> */}
    <Layout path="/addProvider/:provider?/:id?" component={RequireAuth(AddProvider)} />
    <Layout path="/addBucket/:provider?/:id?" component={RequireAuth(AddBucket)}/>
    <Layout path="/setAlert/:id?/:name?" component={RequireAuth(SetAlert)} />
    <Layout path="/cloud-compare/:id" component={RequireAuth(CloudCompare)} />

    <Layout path="/encoding" component={RequireAuth(Encoding)} />
    <Layout path="/hybrik" component={RequireAuth(Hybrik)} />

    {/* wasabi only =========================== */}

    <Route path="/verifyemail" component={VerifyEmail}/>

    <Layout path="/cloudproviders" component={RequireAuth(CloudProviders)} />
    {/* <Layout path="/adminDashboard" component={RequireAuth(AdminDashboard)} /> */}
    <Layout path="/userList" component={RequireAuth(UserDashboard)} />
    {/* <Layout path="/userDashboard" component={RequireAuth(EachUserDashboard)} /> */}
    <Layout path="/usageDetail" component={RequireAuth(UsageDetail)} />
    <Layout path="/transferCostDetail" component={RequireAuth(TransferCostDetail)} />

    <Layout path="/admindaccount" component={RequireAuth(AdmindAccount)} />
    <Layout path="/addNewAccount" component={RequireAuth(AddNewAccount)} />
    <Layout path="/addNewUser" component={RequireAuth(AddNewUser)} />


    {/* ======================================== */}

    <Settings path="/profile" exact component={RequireAuth(ProfileDetails)} />
    <Settings path="/profile/edit" component={RequireAuth(EditProfile)} />
    <Settings
      path="/profile/changepassword"
      component={RequireAuth(ChangePassword)}
    />

    <Settings path="/billing" exact component={RequireAuth(BillingDetails)} />
    <Settings
      path="/billing/addcreditcard/:subscriptionId?"
      component={RequireAuth(AddCreditCard)}
    />

    <Settings
      path="/users"
      exact
      component={RequireAuth(RequireAdmin(UserList))}
    />
    <Settings
      path="/users/invite"
      component={RequireAuth(RequireAdmin(UserList))}
    />
    <Settings path="/roles" component={RequireAuth(RequireAdmin(RoleList))} />
    <Settings path="/security-credentials" component={RequireAuth(RequireAdmin(SecurityCredentials))} />
    
    <Settings
      path="/users/:id"
      component={RequireAuth(RequireAdmin(UserPage))}
    />
    <Settings
      path="/mfa"
      component={RequireAuth(MFAPage)}
    />

    
    <Settings path="/plan" component={RequireAuth(PlanDetails)} />
    <Settings path="/pricings" component={RequireAuth(Pricings)} />
    <Layout path="/logs" component={RequireAuth(LogsView)} fullHeight={true} />
    <Layout path="/finance" component={RequireAuth(Finance)} />

    <Layout path="/onboard/:type" component={RequireAuth(Hybrid)} />
    <Layout path="/dashboard" component={RequireAuth(Dashboard)} />

    <Layout path="/migration" component={RequireAuth(Xchange)} />
    <Layout path="/sync" component={RequireAuth(SyncC2c)} />
    <Layout path="/replication" component={RequireAuth(SyncC2cWasabi)} />
    <Layout path="/calc" component={RequireAuth(CalcPrice)} />
    <Layout path="/mboard" component={RequireAuth(Transfer)} />
    <Layout path="/rboard" component={RequireAuth(Transfer)} />    
    <Layout path="/wbrstatus" component={RequireAuth(TransferWasabi)} />
    <Layout path="/awstboard" component={RequireAuth(TransferLambda)} />
    <Layout path="/prod2" component={RequireAuth(XchangeAWS)} />
    <Layout path="/prod3" component={RequireAuth(XchangeAWS2)} />
    <Layout path="/wasabic2c" component={RequireAuth(XchangeWasabi)} />

    {/* <Layout path="/" component={RequireAuth(Hybrid)} /> */}
    <Layout path="/" component={RequireAuth(Dashboard)} />


  </Switch>
)
